import React, {
  useEffect,
  useState,
  useRef,
  useCallback,
  useMemo,
} from "react";
import axios from "axios";

import { useParams, Link } from "react-router-dom";
import Select from "react-select";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import jsPDF from "jspdf";
import JsBarcode from "jsbarcode";
import CountUp from "react-countup";
import { TreeSelect } from "primereact/treeselect";

//import { Field, Form, Formik } from "formik";

import * as XLSX from "xlsx";

import moment from "moment";
import ReportDate from "../../../components/Reports/ReportDate";

import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "../../../assets/css/customersummary.css";
import "jspdf-autotable";
import Moment from "moment";

//--------Material React Table------//
import { MaterialReactTable } from "material-react-table";
import { Box, Button } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../../common/Constant";
import CommonMatrialReactTable from "../../../components/Datatable/CommonMatrialReactTable";

const currentDate = new Date();
const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const month = monthNames[currentDate.getMonth()]; // add 1 to get month value from 1 to 12
const hours = currentDate.getUTCHours();
const minutes = currentDate.getUTCMinutes();

const ItemSummaryReport = (props) => {
  const locationid = localStorage.getItem("Location");
  const gridRef = useRef();
  const token = localStorage.getItem("Token");
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalSum, setTotalSum] = useState(0);
  const [totalbalance, setTotalBalance] = useState(0);

  const [startdate, setStartDate] = useState("");
  const [enddate, setEndDate] = useState("");
  const [selectedDate, setSelectedDate] = useState([]);
  const [selectedItemsToShowList, setselectedItemsToShowList] = useState([
    { label: "Items with sale", value: 1 },
    { label: "Items without sale", value: 2 },
  ]);
  const [selectedItemsToShowId, setselectedItemsToShowId] = useState(1);

  const [selectReport, setSelectReport] = useState(7);
  const [TierList, setTierList] = useState([]);
  const [tierid, settierid] = useState(0);
  const [salesTypeValue, setSalesTypeValue] = useState();
  const [salesTypeID, setSalesTypeID] = useState(0);
  const [saletype, setSaletype] = useState([]);
  const [supplierID, setSupplierID] = useState(0);
  const [supplierValue, setsupplierValue] = useState();
  const [SecondCategories, setSecondCategories] = useState([]);
  const [categoryID, setCategoryID] = useState(0);
  const [customerID, setCustomerID] = useState(0);
  const [customerValue, setCustomerValue] = useState();
  const [custoptions, setCustOptions] = useState([]);

  //----------------Server-Side------------------//
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 25,
  });

  const [totalData, setTotalData] = useState({
    Totalsum: 0,
    SubTotalsum: 0,
    Taxsum: 0,
    Profitsum: 0,
    TotalNumberOfItemsSoldsum: 0,
    CostOfGoodsSoldsum: 0,
    DamagedQuantitysum: 0,
  });
  const [recoptions, setRecOptions] = useState([
    {
      Id: Number,
      CompanyName: String,
      FirstName: String,
      LastName: String,
      Email: String,
      PhoneNumber: Number,
      Address1: String,
      City: String,
      StateProvince: String,
      Zip: Number,
      Country: String,
    },
  ]);
  const supplierDropDown = recoptions.map((option) => ({
    value: option.ID,
    // label: option.FirstName + " " + option.LastName,
    label:
      option.CompanyName +
      " (" +
      (option.FirstName + " " + option.LastName) +
      ")",
    address: option.Address,
  }));

  const ITEMS_PER_PAGE = 10;

  const barcodeRefs = useRef([]);
  let index = 0;
  const [data, setData] = useState({
    inputValue: "",
    width: 1,
    height: 20,
    fontSize: 15,
    zeroFill: 10,
  });

  //Function to generate barcode
  const generateBarcodes = () => {
    barcodeRefs.current.forEach((barcodeRef, index) => {
      console.log("barcodeRefs", barcodeRefs);
      var g = document.getElementsByTagName(barcodeRef);
      const barcodeValue = paramObject.id;
      console.log("barcodeValue", barcodeValue);
      const paddedBarcodeValue = barcodeValue.padStart(data.zeroFill, "0");
      JsBarcode(barcodeRef, paddedBarcodeValue, {
        width: data.width,
        height: data.height,
        fontSize: data.fontSize,
        displayValue: true,
        fontoptions: "bold",
        textAlign: "center",
        font: "monospace",
        textPosition: "bottom",
        textMargin: 2,
        margin: 10,
        marginTop: undefined,
        marginBottom: undefined,
        marginLeft: undefined,
        marginRight: undefined,
        format: "CODE128",
        valid: () => true,
        background: "#ffffff",
        lineColor: "#000000",
        padding: data.zeroFill,
      });
    });
  };

  //Function for downloading pdf of barcodesheet

  //Function for download

  const handleDropdownChange = (event) => {
    setSelectReport(event?.value);
  };

  const handleItemsTypeChange = (event) => {
    // setselectedItemsToShowList(event?.value);
    setselectedItemsToShowId(event.value);
  };

  console.log(selectedItemsToShowId, "selectedItemsToShowId");

  const handleChangeTier = (event, index) => {
    console.log(event?.label, event?.value, event?.id, "handleChangeTier");
    settierid(event?.id);
  };

  const handleChangeSalesType = (event) => {
    console.log(event, "handleChangeSalesType");
    setSalesTypeValue(event);
    setSalesTypeID(event?.value);
  };
  const handleChangeCustomer = (event) => {
    setCustomerValue(event);
    setCustomerID(event?.value);
  };
  const handleCategoryChanged = (event) => {
    setCategoryID(event?.value);
  };

  let salesTypeDropdownOption = [];
  const SalesTypeDropdown = saletype.map((u, i) => {
    salesTypeDropdownOption[i] = { label: u.SalesType, value: u.ID };
  });

  let Catagories = [];
  const ItemCategories = SecondCategories.map((u, i) => {
    Catagories[i] = { label: u.Name, value: u.ID };
  });
  const customerDropDown = custoptions.map((option) => ({
    value: option.Id,
    label:
      option.CompanyName +
      " (" +
      (option.FirstName + " " + option.LastName) +
      ")",
    address: option.Address1,
    email: option.Email,
  }));

  //Function for lookup receipt
  const paramObject = useParams();

  useEffect(() => {
    const columnIndex = sorting.length > 0 ? sorting[0]?.id : "";
    console.log(
      JSON.stringify(columnFilters) + " columnFilters | ",
      globalFilter + " globalFilter | ",
      pagination.pageIndex + " pagination.pageIndex | ",
      pagination.pageSize + " pagination.pageSize | ",
      columnIndex,
      sorting[0]?.id,
      sorting[0]?.desc === undefined
        ? "desc"
        : (sorting[0]?.desc === true ? "desc" : "asc") + " sorting | ",
      startdate + " startdate | ",
      enddate + " enddate",
      tierid + " tierid",
      customerID + " customerid",
      salesTypeID + " saletype",
      categoryID + " categoryid",
      locationid + " locationid",

      "api Call payload"
    );

    const FilterColumnText = {};
    FilterColumnText.filtercolumntext = columnFilters.map((el, index) => {
      return { columnname: el.id, value: el.value, id: index + 1 };
    });

    let FilterColumnSearchText = JSON.stringify(FilterColumnText);

    if (selectedItemsToShowId === 1) {
      axios
        .get(
          `${
            config.reportsBaseUrl
          }/reports/itemsummaryreport?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
            sorting[0]?.desc === undefined
              ? "desc"
              : sorting[0]?.desc === true
              ? "desc"
              : "asc"
          }&ordercolumn=${columnIndex}&pagesize=${
            pagination.pageSize
          }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
            globalFilter === undefined ? "" : globalFilter
          }&startdate=${startdate}&enddate=${enddate}&tierid=${tierid === undefined ? 0 : tierid}&customerid=${
            customerID === undefined ? 0 : customerID
          }&categoryid=${
            categoryID === undefined ? 0 : categoryID
          }&saletype=${salesTypeID === undefined ? 0 : salesTypeID}&locationid=${locationid}
            `,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              "Access-Control-Allow-Origin": "*",
              Authorization: token,
            },
          }
        )

        .then((res) => {
          console.log("res======>", res);
          console.log(res.data.ResponseData, "res======>");
          if (res.data.ResponseCode === "SUCCESS") {
            const numArr = res.data.ResponseData.map(obj => {
              return {
                ...obj,
              Profit: obj.Profit ? Number(obj.Profit) : 0 ,
              CostOfGoodsSold: obj.CostOfGoodsSold ? Number(obj.CostOfGoodsSold) : 0 ,
              Quantity: obj.Quantity ? Number(obj.Quantity) : "" ,
              QuantityPurchased: obj.QuantityPurchased ? Number(obj.QuantityPurchased) : "" ,
              Subtotal: obj.Subtotal ? Number(obj.Subtotal) : "" ,
              Total: obj.Total ? Number(obj.Total) : 0 ,
              Manufacturer: obj.Manufacturer ? obj.Manufacturer : ""
              };
            });
            setResponseData(numArr);
            setData(numArr);
            if (res.data.ResponseData.length > 0) {
              setRowCount(res.data.ResponseData[0].TotalRecord);
              setTotalData({
                ...totalData,
                Totalsum: res.data.ResponseData[0].Totalsum,
                SubTotalsum: res.data.ResponseData[0].SubTotalsum,
                Taxsum: res.data.ResponseData[0].Taxsum,
                CostOfGoodsSoldsum: res.data.ResponseData[0].CostOfGoodsSoldsum,
                Profitsum: res.data.ResponseData[0].Profitsum,
                TotalNumberOfItemsSoldsum:
                  res.data.ResponseData[0].TotalNumberOfItemsSold,
                DamagedQuantitysum: res.data.ResponseData[0].DamagedQuantitysum,
              });
            } else {
              setRowCount(0);
              setTotalData({
                ...totalData,
                Totalsum: 0,
                SubTotalsum: 0,
                Taxsum: 0,
                CostOfGoodsSoldsum: 0,
                Profitsum: 0,
                TotalNumberOfItemsSoldsum: 0,
                DamagedQuantitysum: 0,
              });
            }
            //   barcodeRefs.current = responseData;
          }
          setLoading(false);
        })
        .catch((err) => {
          setIsError(true);
          console.log(err);
          setLoading(false);
          return;
        });
    } else {
      axios
        .get(
          `${
            config.reportsBaseUrl
          }/reports/itemswithoutsale?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
            sorting[0]?.desc === undefined
              ? "desc"
              : sorting[0]?.desc === true
              ? "desc"
              : "asc"
          }&ordercolumn=${columnIndex}&pagesize=${
            pagination.pageSize
          }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
            globalFilter === undefined ? "" : globalFilter
          }&categoryid=${categoryID === undefined ? 0 : categoryID}&locationid=${locationid}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          console.log("res======>", res);
          console.log(res.data.ResponseData, "res======>");
          if (res.data.ResponseCode === "SUCCESS") {

            const numArr = res.data.ResponseData.map(obj => {
              return {
                ...obj,
              Profit: obj.Profit ? Number(obj.Profit) : 0 ,
              CostOfGoodsSold: obj.CostOfGoodsSold ? Number(obj.CostOfGoodsSold) : 0 ,
              Quantity: obj.Quantity !== null ? Number(obj.Quantity) : 0 ,
              Manufacturer: obj.Manufacturer ? obj.Manufacturer : ""
              };
            });
            setResponseData(numArr);
            setData(numArr);
            if (res.data.ResponseData.length > 0) {
              setRowCount(res.data.ResponseData[0].TotalRecord);
            }
          }
        });
    }

    setIsError(false);
    setIsLoading(false);
    setIsRefetching(false);
  }, [
    columnFilters,
    globalFilter,
    pagination.pageIndex,
    pagination.pageSize,
    sorting,
    startdate,
    enddate,
    tierid,
    customerID,
    salesTypeID,
    categoryID,
    locationid,
    selectedItemsToShowId,
  ]);

  console.log(responseData, "responseData168");
  useEffect(() => {
    generateBarcodes();
    console.log("barcodeRefs", barcodeRefs);
    setLoading(true);

    axios
      .get(`${config.reportsBaseUrl}/reports/reportperioddropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("setSelectedDate======>", res);
        setSelectedDate(res.data.ResponseData);
        return res;
      });

    axios
      .get(`${config.storeConfigBaseUrl}/storeconfig/Roletierdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((response) => {
        // console.log(response.data?.ResponseData, "response of tire list")
        setTierList(response.data?.ResponseData);
      })
      .catch((error) => {
        console.log(error.message);
      });

    axios
      .get(`${config.salesconfigBaseUrl}/sales/saletype`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((response) => {
        const FilterData = response.data.ResponseData.filter(el => el.ID !== 3)
        setSaletype(FilterData);
        console.log(response.data.ResponseData, "===> setSaletype");
      })
      .catch((error) => {
        console.log(error);
      });
    axios
      .get(`${config.customersBaseUrl}/customers/customerdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((response) => {
        setCustOptions(response.data.ResponseData);
        console.log(response.data.ResponseData, "===> setCustOptions");
      })
      .catch((error) => {
        console.log(error);
      });
    axios
      .get(`${config.categoriesBaseUrl}/categories?filtertext=${""}`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        // setData(res.data.ResponseData);
        setSecondCategories(res.data.ResponseData);
      });
  }, []);

  // to calculate the total
  const calculateTotalSum = () => {
    const sum = responseData.reduce((total, report) => {
      const reportTotal = Number(report.Amount);

      if (typeof reportTotal === "number" && !isNaN(reportTotal)) {
        return total + reportTotal;
      } else {
        return total;
      }
    }, 0);

    setTotalSum(sum);
  };

  // to calculate the total
  const calculateTotalBalance = () => {
    const sum = responseData.reduce((total, report) => {
      const reportTotal = Number(report.Balance);

      if (typeof reportTotal === "number" && !isNaN(reportTotal)) {
        return total + reportTotal;
      } else {
        return total;
      }
    }, 0);

    setTotalBalance(sum);
  };

  useEffect(() => {
    calculateTotalSum();
    calculateTotalBalance();
  }, [responseData]);

  const callback = (payload, enddate2) => {
    console.log("stardate =>", payload);
    setStartDate(payload);
    setEndDate(enddate2);

    console.log("enddate =>", enddate2);
  };


  const columns = useMemo(() =>
    selectedItemsToShowId === 1
      ? [
          {
            header: "Item ID",
            accessorKey: "ItemID",
            filterFn : "contains",
            size: 100,
          },
          {
            header: "Variation ID",
            accessorKey: "VariationID",
            filterFn : "contains",
            size: 120,
          },
          {
            header: "Item/ Variation Name",
            filterFn : "contains",
            accessorKey: "Item",
          },
          {
            header: "Item Number",
            accessorKey: "ItemNumber",
            filterFn : "contains",
            size: 120,
          },
          {
            header: "Product ID",
            accessorKey: "ProductID",
            filterFn : "contains",
            size: 120,
          },
          {
            header: "Supplier",
            accessorKey: "Supplier",
            filterFn : "contains",
            size: 140,
          },
          {
            header: "Category",
            accessorKey: "Category",
            filterFn : "contains",
            size: 120,
          },
          {
            header: "Current Cost Price",
            accessorKey: "CurrentCostPrice",
            filterFn : "contains",
            size: 130,
          },
          {
            header: "Current Selling Price",
            accessorKey: "CurrentSellingPrice",
            filterFn : "contains",
            size: 130,
          },
          {
            header: "Quantity",
            accessorKey: "Quantity",
            filterFn : "contains",
            size: 120,
            AggregatedCell: ({ cell, table }) => (
              <>
                Oldest by{" "}
                {table.getColumn(cell.row.groupingColumnId ?? "").columnDef.header}:{" "}
                <Box
                  sx={{ color: "info.main", display: "inline", fontWeight: "bold" }}
                >
                  {" " +
                    cell.getValue()?.toLocaleString?.("en-US", {
                      style: "currency",
                      currency: "USD",
                      // minimumFractionDigits: 0,
                      // maximumFractionDigits: 0,
                    })}
                </Box>
              </>
            ),
          },

          {
            header: "Quantity Sold",
            accessorKey: "QuantityPurchased",
            filterFn : "contains",
            size: 120,
            AggregatedCell: ({ cell, table }) => (
              <>
                Oldest by{" "}
                {table.getColumn(cell.row.groupingColumnId ?? "").columnDef.header}:{" "}
                <Box
                  sx={{ color: "info.main", display: "inline", fontWeight: "bold" }}
                >
                  {" " +
                    cell.getValue()?.toLocaleString?.("en-US", {
                      style: "currency",
                      currency: "USD",
                      // minimumFractionDigits: 0,
                      // maximumFractionDigits: 0,
                    })}
                </Box>
              </>
            ),
          },
          {
            header: "Subtotal",
            accessorKey: "Subtotal",
            filterFn : "contains",
            size: 120,
            AggregatedCell: ({ cell, table }) => (
              <>
                Oldest by{" "}
                {table.getColumn(cell.row.groupingColumnId ?? "").columnDef.header}:{" "}
                <Box
                  sx={{ color: "info.main", display: "inline", fontWeight: "bold" }}
                >
                  {" " +
                    cell.getValue()?.toLocaleString?.("en-US", {
                      style: "currency",
                      currency: "USD",
                      // minimumFractionDigits: 0,
                      // maximumFractionDigits: 0,
                    })}
                </Box>
              </>
            ),
          },
          {
            header: "Total",
            accessorKey: "Total",
            filterFn : "contains",
            size: 120,
            AggregatedCell: ({ cell, table }) => (
              <>
                Oldest by{" "}
                {table.getColumn(cell.row.groupingColumnId ?? "").columnDef.header}:{" "}
                <Box
                  sx={{ color: "info.main", display: "inline", fontWeight: "bold" }}
                >
                  {" " +
                    cell.getValue()?.toLocaleString?.("en-US", {
                      style: "currency",
                      currency: "USD",
                      // minimumFractionDigits: 0,
                      // maximumFractionDigits: 0,
                    })}
                </Box>
              </>
            ),
          },
          {
            header: "Tax",
            accessorKey: "Tax",
            filterFn : "contains",
            size: 120,
            
          },
          {
            header: "Profit",
            accessorKey: "Profit",
            filterFn : "contains",
            size: 120,
            AggregatedCell: ({ cell, table }) => (
              <>
                Oldest by{" "}
                {table.getColumn(cell.row.groupingColumnId ?? "").columnDef.header}:{" "}
                <Box
                  sx={{ color: "info.main", display: "inline", fontWeight: "bold" }}
                >
                  {" " +
                    cell.getValue()?.toLocaleString?.("en-US", {
                      style: "currency",
                      currency: "USD",
                      // minimumFractionDigits: 0,
                      // maximumFractionDigits: 0,
                    })}
                </Box>
              </>
            ),
          },
          {
            header: "Cost Of Goods Sold",
            accessorKey: "CostOfGoodsSold",
            filterFn : "contains",
            size: 120,
            AggregatedCell: ({ cell, table }) => (
              <>
                Oldest by{" "}
                {table.getColumn(cell.row.groupingColumnId ?? "").columnDef.header}:{" "}
                <Box
                  sx={{ color: "info.main", display: "inline", fontWeight: "bold" }}
                >
                  {" " +
                    cell.getValue()?.toLocaleString?.("en-US", {
                      style: "currency",
                      currency: "USD",
                      // minimumFractionDigits: 0,
                      // maximumFractionDigits: 0,
                    })}
                </Box>
              </>
            ),
          },
          {
            header: "Manufacturer",
            accessorKey: "Manufacturer",
            filterFn : "contains",
            size: 150,
          },
        ]
      : [
          {
            header: "Item ID",
            accessorKey: "ItemID",
            filterFn : "contains",
            size: 100
          },
          {
            header: "Variation ID",
            accessorKey: "VariationID",
            filterFn : "contains",
            size: 120
          },
          {
            header: "Item/ Variation Name",
            accessorKey: "Item",
            filterFn : "contains",
          },
          {
            header: "Item Number",
            accessorKey: "ItemNumber",
            filterFn : "contains",
            size: 120,
          },
          {
            header: "Product ID",
            accessorKey: "ProductID",
            filterFn : "contains",
            size: 120,
          },
          {
            header: "Supplier",
            accessorKey: "Supplier",
            filterFn : "contains",
            size: 140,
          },
          {
            header: "Category",
            accessorKey: "Category",
            filterFn : "contains",
            size: 120,
          },
          {
            header: "Current Cost Price",
            accessorKey: "CurrentCostPrice",
            filterFn : "contains",
            size: 130,
          },
          {
            header: "Current Selling Price",
            accessorKey: "CurrentSellingPrice",
            filterFn : "contains",
            size: 130,
          },
          {
            header: "Quantity",
            accessorKey: "Quantity",
            filterFn : "contains",
            size: 120,
            AggregatedCell: ({ cell, table }) => (
              <>
                Oldest by{" "}
                {table.getColumn(cell.row.groupingColumnId ?? "").columnDef.header}:{" "}
                <Box
                  sx={{ color: "info.main", display: "inline", fontWeight: "bold" }}
                >
                  {" " +
                    cell.getValue()?.toLocaleString?.("en-US", {
                      style: "currency",
                      currency: "USD",
                      // minimumFractionDigits: 0,
                      // maximumFractionDigits: 0,
                    })}
                </Box>
              </>
            ),
          },
          {
            header: "Manufacturer",
            accessorKey: "Manufacturer",
            filterFn : "contains",
            size: 150,
          },
        ]
  );


  let dashStyle = {
    // width: "280px",
    background: "#fff",
    marginTop: "10px",
    borderRadius: "6px",
    padding: "20px",
    border: "1px solid #E8EBED",
  };

  let reportdropdown = [];
  const data2 = selectedDate.map(
    (u, i) => (reportdropdown[i] = { label: u.Name, value: u.ID })
  );

  // let itemstoshowdropdown = [];
  // const data3 = selectedItemsToShowList.map(
  //   (u, i) => (itemstoshowdropdown[i] = { label: u.Name, value: u.ID })
  // );

  console.log(TierList, "TierList");

  console.log(responseData, "responseData941");
  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <h3 className="page-title">Customer Balance Detail</h3> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/reports">Report</Link>
                </li>
                <li className="breadcrumb-item active">Items Summary Report</li>
              </ul>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-3">
              <label className="col-form-label col-md-5 form-label p-lg-medium">
                Items To Show
              </label>
              <div className="row">
                <div className="col-md-11 z-5">
                  <Select
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    options={selectedItemsToShowList}
                    // defaultValue={selectReport}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    isClearable={true}
                    name="Itemstoshow"
                    id="Itemstoshow"
                    value={selectedItemsToShowList.find(
                      (e) => e.value === selectedItemsToShowId
                    )}
                    onChange={(event) => {
                      handleItemsTypeChange(event);
                    }}
                    className="w-100 custom-search-select"
                  ></Select>
                </div>
              </div>
            </div>
            <div className="col-sm-3">
              <label className="col-form-label col-md-5 form-label p-lg-medium">
                Category
              </label>
              <div className="row">
                <div className="col-md-11 z-4">
                  <Select
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    isClearable={true}
                    // onChange={setselectedCategory}
                    onChange={(e) => handleCategoryChanged(e)}
                    options={Catagories}
                    // placeholder="Categories"
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    value={
                      Catagories.find(
                        (option) => option?.value === categoryID
                      ) || ""
                    }
                    id="Category"
                    name="Category"
                    className="w-100 custom-search-select"
                  />
                </div>
              </div>
            </div>
            {selectedItemsToShowId === 1 && (
              <>
                <div className="col-sm-3">
                  <label className="col-form-label col-md-5 form-label p-lg-medium">
                    Sale Type
                  </label>
                  <div className="row">
                    <div className="col-md-11 z-4">
                      <Select
                        defaultValue={salesTypeValue}
                        onChange={(event) => {
                          handleChangeSalesType(event);
                        }}
                        options={salesTypeDropdownOption}
                        backspaceRemovesValue={false}
                        controlShouldRenderValue={true}
                        hideSelectedOptions={true}
                        isClearable={true}
                        styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                        className="custom-search-select mt-1"
                        isDisabled={selectedItemsToShowId === 1 ? false : true}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-sm-3">
                  <label className="col-form-label col-md-5 form-label p-lg-medium">
                    Customer
                  </label>
                  <div className="row">
                    <div className="col-md-11 z-4">
                      <Select
                        defaultValue={customerValue}
                        onChange={(event) => {
                          handleChangeCustomer(event);
                        }}
                        options={customerDropDown}
                        backspaceRemovesValue={false}
                        controlShouldRenderValue={true}
                        isClearable={true}
                        styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                        className="custom-search-select mt-1"
                        isDisabled={selectedItemsToShowId === 1 ? false : true}
                      />
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
          {selectedItemsToShowId === 1 && (
            <div className="row">
              <div className="col-sm-3 z-4">
                <label className="col-form-label col-md-5 form-label p-lg-medium">
                  Tier Name
                </label>
                <div className="row">
                  <div className="col-md-11 z-3">
                    <Select
                      options={TierList.map((tire) => ({
                        label: tire.Name,
                        value: tire.Code,
                        id: tire.ID,
                      }))}
                      backspaceRemovesValue={false}
                      controlShouldRenderValue={true}
                      hideSelectedOptions={true}
                      isClearable={true}
                      styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                      onChange={(e, index) => handleChangeTier(e, index)}
                      className="custom-select-search"
                      isDisabled={selectedItemsToShowId === 1 ? false : true}
                    />
                  </div>
                </div>
              </div>
              <div className="col-sm-3">
                <label className="col-form-label col-md-5 form-label p-lg-medium">
                  Report period
                </label>
                <div className="row">
                  <div className="col-md-11 z-3">
                    <Select
                      styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                      options={reportdropdown}
                      // defaultValue={selectReport}
                      backspaceRemovesValue={false}
                      controlShouldRenderValue={true}
                      hideSelectedOptions={true}
                      isClearable={true}
                      name="Reportperiod"
                      id="Reportperiod"
                      value={reportdropdown.find(
                        (e) => e.value === selectReport
                      )}
                      onChange={(event) => {
                        handleDropdownChange(event);
                      }}
                      className="custom-search-select"
                      isDisabled={selectedItemsToShowId === 1 ? false : true}
                    ></Select>
                  </div>
                </div>
              </div>
              <div className="col-sm-6">
                <div className="row">
                  <ReportDate
                    callback={callback}
                    selectReport={selectReport}
                    showhidecomponent={
                      selectReport == 2 ||
                      selectReport == 3 ||
                      selectReport == 4 ||
                      selectReport == 5 ||
                      selectReport == 6 ||
                      selectReport == 7 ||
                      selectReport == 8 ||
                      selectReport == 9 ||
                      selectReport == 10 ||
                      selectReport == 11 ||
                      selectReport == 12 ||
                      selectReport == 13 ||
                      selectReport == 14 ||
                      selectReport == 15 ||
                      selectReport == 16 ||
                      selectReport == 17 ||
                      selectReport == 18 ||
                      selectReport == 19 ||
                      selectReport == 20 ||
                      selectReport == 21 ||
                      selectReport == 22 ||
                      selectReport == 23 ||
                      selectReport == 24 ||
                      selectReport == 25 ||
                      selectReport == 26 ||
                      selectReport == 27 ||
                      selectReport == 28 ||
                      selectReport == 29 ||
                      selectReport == 30 ||
                      selectReport == 31
                        ? true
                        : false
                    }
                  />
                </div>
              </div>
            </div>
          )}
          {selectedItemsToShowId === 1 && (
            <div
              className="row"
              style={{
                display: "grid",
                gap: "1rem",
                // gridTemplateColumns: "repeat(5,1fr)"
                gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
              }}
            >
              <div className="cards">
                <div className="dash-widget" style={dashStyle}>
                  <div className="dash-widgetimg"></div>
                  <div className="dash-widgetcontent">
                    <p className="p-20">${totalData.SubTotalsum}</p>
                    <div className="d-flex">
                      <p className="p-medium">Subtotal</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="cards">
                <div className="dash-widget" style={dashStyle}>
                  <div className="dash-widgetimg"></div>
                  <div className="dash-widgetcontent">
                    <p className="p-20">${totalData.Totalsum}</p>
                    <div className="d-flex">
                      <p className="p-medium">Total </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="cards">
                <div className="dash-widget" style={dashStyle}>
                  <div className="dash-widgetimg"></div>
                  <div className="dash-widgetcontent">
                    <p className="p-20">${totalData.Taxsum}</p>
                    <div className="d-flex">
                      <p className="p-medium">Tax</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="cards">
                <div className="dash-widget" style={dashStyle}>
                  <div className="dash-widgetimg"></div>
                  <div className="dash-widgetcontent">
                    <p className="p-20">
                      ${totalData.TotalNumberOfItemsSoldsum}
                    </p>
                    <div className="d-flex">
                      <p className="p-medium">Total Number Of Items Sold </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="cards">
                <div className="dash-widget" style={dashStyle}>
                  <div className="dash-widgetimg"></div>
                  <div className="dash-widgetcontent">
                    <p className="p-20">${totalData.Profitsum}</p>
                    <div className="d-flex">
                      <p className="p-medium">Profit</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="cards">
                <div className="dash-widget" style={dashStyle}>
                  <div className="dash-widgetimg"></div>
                  <div className="dash-widgetcontent">
                    <p className="p-20">${totalData.CostOfGoodsSoldsum}</p>
                    <div className="d-flex">
                      <p className="p-medium">Cost Of Goods Sold </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="cards">
                <div className="dash-widget" style={dashStyle}>
                  <div className="dash-widgetimg"></div>
                  <div className="dash-widgetcontent">
                    <p className="p-20">${totalData.DamagedQuantitysum}</p>
                    <div className="d-flex">
                      <p className="p-medium">Damaged Qty </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {/* Receipt */}

          <div className="card mt-3">
            <div className="card-body">
              <div className="container">
                <div className="col-md-12 text-center " id="header">
                  <h6 class="p">SonarPos</h6>
                  <p className="fw-bold p-regular">Items Summary Report</p>
                  <div className="row mb-2">
                    {/* <h6> Date: {new Date().toLocaleDateString()}</h6>
                          <p >
                            Date: {startdate} - {enddate}
                          </p> */}
                    <p>
                      Date:{" "}
                      {startdate === "" && enddate === ""
                        ? "All Data"
                        : startdate + " - " + enddate}
                    </p>
                  </div>
                </div>
              </div>
              <hr />

              <div className="table-responsive">
                <div className="table mt-3"></div>

                <div>
                  {/* <MaterialReactTable
                    muiTableContainerProps={{
                      sx: { maxHeight: "fit-content" },
                    }}
                    columns={columns}
                    data={data}
                    enableColumnResizing
                    enableGrouping
                    enableColumnFilters
                    shortDescFirst={true}
                    enableStickyHeader
                    enableStickyFooter
                    enableRowSelection
                    enableColumnOrdering
                    sortDescFirst
                    muiTableBodyProps={{
                      sx: () => ({
                        "& tr:nth-of-type(even)": {
                          backgroundColor:
                            "var(--datatable-row-background-color)",
                          //'rgb(237 237 233 / 63%)'
                        },
                        "& td": {
                          borderRight:
                            "1px solid var(--datatable-row-background-hover-color)",
                          lineHeight: "16px",
                          fontWeight: "400",
                          fontSize: "12px",
                          color: "var(--primary-color-800)",
                          fontFamily: "Inter",
                        },

                        "& tr": {
                          lineHeight: "16px",
                          fontWeight: "400",
                          fontSize: "12px",
                          color: "var(--primary-color-800)",
                          fontFamily: "Inter",
                        },
                      }),
                    }}
                    muiTableHeadCellProps={{
                      sx: (theme) => ({
                        background: "var(--datatable-row-background-color)", //'#e9e9e9',
                        borderRight:
                          "1px solid var(--datatable-row-background-hover-color)",
                        lineHeight: "16px",
                        fontWeight: "500",
                        fontSize: "14px",
                        color: "var(--primary-color-800)",
                        fontFamily: "Inter",
                      }),
                    }}
                    muiToolbarAlertBannerProps={{
                      isError: () => ({
                        color: "error",
                        children: "Error loading data",
                      }),
                      sx: (theme) => ({
                        background: "var(--datatable-row-background-color)", //'#e9e9e9',
                        lineHeight: "16px",
                        fontWeight: "500",
                        fontSize: "14px",
                        color: "var(--primary-color-800)",
                        fontFamily: "Inter",
                      }),
                    }}
                    muiSelectCheckboxProps={{
                      sx: (theme) => ({
                        lineHeight: "16px",
                        fontWeight: "400",
                        fontSize: "12px",
                        color: "var(--prinary-color-800)",
                        fontFamily: "Inter",
                      }),
                    }}
                    muiSelectAllCheckboxProps={{
                      sx: (theme) => ({
                        lineHeight: "16px",
                        fontWeight: "400",
                        fontSize: "12px",
                        color: "var(--prinary-color-800)",
                        fontFamily: "Inter",
                      }),
                    }}
                    initialState={{
                      density: "compact",
                      expanded: true, //expand all groups by default
                      grouping: ["ItemID"], //an array of columns to group by by default (can be multiple)
                      pagination: { pageIndex: 0, pageSize: 25 },
                      sorting: [{ id: "state", desc: false }], //sort by state by default
                    }}
                    // muiToolbarAlertBannerChipProps={{ color: "primary" }}
                    // muiTableContainerProps={{ sx: { maxHeight: 700 } }}
                    muiPaginationProps={{
                      rowsPerPageOptions: [25, 50, 100, 300, 500],
                    }}
                    manualFiltering
                    manualPagination
                    manualSorting
                    onColumnFiltersChange={setColumnFilters}
                    onGlobalFilterChange={setGlobalFilter}
                    onPaginationChange={setPagination}
                    onSortingChange={setSorting}
                    rowCount={rowCount}
                    state={{
                      columnFilters,
                      globalFilter,
                      isLoading,
                      pagination,
                      showAlertBanner: isError,
                      showProgressBars: isRefetching,
                      sorting,
                    }}
                    renderTopToolbarCustomActions={({ table }) => (
                      <Box
                        sx={{
                          display: "flex",
                          gap: "0.5rem",
                          p: "0.5rem",
                          flexWrap: "wrap",
                        }}
                      >
                        <Button
                          // size="small"
                          class="btn btn-sm btn-secondary"
                          style={{ display: "flex" }}
                          //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                          onClick={onBtExport}
                          startIcon={<FileDownloadIcon />}
                          variant="contained"
                        >
                          Export All In Excel
                        </Button>
                        <Button
                          // size="small"
                          class="btn btn-sm btn-secondary"
                          style={{ display: "flex" }}
                          disabled={
                            !table.getIsSomeRowsSelected() &&
                            !table.getIsAllRowsSelected()
                          }
                          //only export selected rows
                          onClick={() =>
                            handleExportRows(table.getSelectedRowModel().rows)
                          }
                          startIcon={<FileDownloadIcon />}
                          variant="contained"
                        >
                          Export Selected Rows in Excel
                        </Button>

                        <Button
                          // size="small"
                          class="btn btn-sm btn-secondary"
                          style={{ display: "flex" }}
                          color="primary"
                          //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                          onClick={() =>
                            downloadPDF(
                              "",
                              "alldata",
                              table.getVisibleFlatColumns()
                            )
                          }
                          startIcon={<FileDownloadIcon />}
                          variant="contained"
                        >
                          Export All In Pdf
                        </Button>
                        <Button
                          // size="small"
                          class="btn btn-sm btn-secondary"
                          style={{ display: "flex" }}
                          disabled={
                            !table.getIsSomeRowsSelected() &&
                            !table.getIsAllRowsSelected()
                          }
                          //only export selected rows
                          onClick={() =>
                            downloadPDF(
                              table.getSelectedRowModel().rows,
                              "selectedrow",
                              table.getVisibleFlatColumns()
                            )
                          }
                          startIcon={<FileDownloadIcon />}
                          variant="contained"
                        >
                          Export Selected Rows in Pdf
                        </Button>
                      </Box>
                    )}
                  /> */}

                    <CommonMatrialReactTable
                    MainHeading="Sonar POS"
                    ReportHeading="Items Summary Report"
                    columns={columns}
                    data={data}
                    startdate={startdate}
                    enddate={enddate}
                    columnGrouping={["ItemID"]}
                    columnsVisibility={{}}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ItemSummaryReport;
